import CircularProgress from '@material-ui/core/CircularProgress'
import React from 'react'

function AppLoader() {
  return (
    <div style={styles}>
      <CircularProgress size={60} />
    </div>
  )
}

const styles: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '100%',
  flexShrink: 0,
  width: '100%',
}

export default AppLoader
